'use strict';

import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.

window.jQuery = $;

require('./lib/browsersupport'); // Toon een upgrade melding als browser niet (goed) wordt ondersteund.
require('foundation-sites');
require('mmenu-js');
require('lazyload');
require('./lib/jquery.waypoints.min.js');
require('./lib/jquery.countup.js');
require('@fancyapps/fancybox');

// If you want to pick and choose which modules to include, comment out the above and uncomment the line below:
//import './lib/foundation-explicit-pieces';

$(document).ready(function () {
  setTimeout(function () {
    $('body').removeClass('preload');
  }, 300);

  // MENU
  if ($("#nav").length != 0) {
    new Mmenu("#nav", {
      // options
    }, {
      // configuration
      offCanvas: {
        page: {
          selector: "#wrapper"
        },
        clone: true
      }
    });
  }

  // FAQ
  $('.faq-question').on('click', function () {
    $(this).toggleClass('active').next('.faq-answer').slideToggle();
  });

  // Lazyload
  var images = document.querySelectorAll('.lazyload');

  lazyload(images);

  // Fancybox
  $('.fancybox').fancybox({
    // Options will go here
  });

  function uniqueId() {
    return Math.round(new Date().getTime() + (Math.random() * 100));
  }

  $( "#nav-call-to-action" ).clone().appendTo( $( ".mm-listview" ) );

  // WP Block Gallery
  if ($('.wp-block-gallery')) {
    var uniqueId = uniqueId();

    $('.wp-block-gallery').each(function () {
      $(this).attr('data-id', uniqueId);
    });

    $('.wp-block-gallery li').each(function () {
      var src = $(this).find('img').attr('src');

      $(this).find('figure').wrap('<a href="' + src + '" data-fancybox="' + uniqueId + '"></a>');
    });

    $('[data-fancybox="gallery"]').fancybox();
  }

  // doneren styling
  function addAmount(amount, amountToAdd) {
    var newAmount = parseFloat(amount) + parseFloat(amountToAdd);

    return formatAmount(newAmount);
  }

  function minusAmount(amount, amountToSubtract) {
      var newAmount = parseFloat(amount) - parseFloat(amountToSubtract);

      return formatAmount(newAmount);
  }

  function formatAmount(amount) {
      if(amount % 1 != 0){
        return parseFloat(amount).toFixed(2);
      }else{
        return parseFloat(amount).toFixed(0);
      }
      
  }

  var intervalAmount = formatAmount($('#form_interval_amount').val());
  var minAmount = formatAmount($('#form_donate_amount').val());
  var startAmount = formatAmount($('#form_start_amount').val());
  var amount = startAmount;

  $('.amount-wrapper button.min').on('click touchdown', function(e) {
      e.preventDefault();

      if (parseFloat(amount) > parseFloat(minAmount)) {
          amount = minusAmount(amount, intervalAmount);
          updateAmount(amount);
      }

      if (parseFloat(amount) <= parseFloat(minAmount)) {
          amount = minAmount;
          updateAmount(amount);
          $('.amount-wrapper button.min').css('visibility', 'hidden');
      }
  });

  $('.amount-wrapper button.plus').on('click touchup', function(e) {
      e.preventDefault();

      $('.amount-wrapper button.min').css('visibility', 'visible');

      amount = addAmount(amount, intervalAmount);
      updateAmount(amount);
  });

    // Scroll to anchor
    $(document).on('click', 'a[href^="#"]', function (event) {
      event.preventDefault();
      $('html, body').animate({
          scrollTop: $($.attr(this, 'href')).offset().top + -120
      }, 1000);
    });

  function updateAmount(amount) {
      $('#form_donate_amount').attr('value', amount);
      $('.amount-wrapper .amount').text(amount);
  }

  if(amount) {
    updateAmount(amount);
  }
  if (parseFloat(amount) <= parseFloat(minAmount)) {
    updateAmount(minAmount);
    $('.amount-wrapper button.min').css('visibility', 'hidden');
  }


});

$(document).foundation();